import './styles/login.css'
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import img from './WhatsApp Image 2024-05-10 at 2.49.27 PM.jpeg';
import React, { useState, useEffect, useRef } from 'react';
import RECAPTCHA from "react-google-recaptcha"

const Login = () => {

  const navigate = useNavigate();
  const captchaRef = useRef(null);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');


  useEffect(() => {
    // Check if user is already logged in
    checkSession();
    
    // Check if there are saved credentials in localStorage
    const savedEmail = localStorage.getItem('email');
    const savedPassword = localStorage.getItem('password');

    setEmail(savedEmail);
    setPassword(savedPassword);
    
  }, []);

  const checkSession = async () => {
    const token = localStorage.getItem('token');
    
    if (token) {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/SessionCheck/checkSession`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': token
          }
        });
        
        const data = await response.json();
        
        if (data.status === 1 && data.session_active) {
          // User is logged in, redirect to dashboard
          console.log('User is logged in:', data.user_name);
          toast.success(`Welcome back, ${data.user_name}!`);
          navigate('/bookings');
        } else {
          // Session expired, clear token and stay on login page
          localStorage.removeItem('token');
          localStorage.removeItem('userPermissions');
          console.log('Session expired, please login again');
        }
      } catch (error) {
        console.error('Error checking session:', error);
        localStorage.removeItem('token');
        localStorage.removeItem('userPermissions');
      }
    }
  };

    function handleSubmit(e) {

        e.preventDefault();


        const data = new URLSearchParams();
        for (const pair of new FormData(document.getElementById("loginForm"))) {
          data.append(pair[0], pair[1]);
        }
        const captcha = captchaRef.current.getValue();
        if(!captcha){
          toast.error("Please verify the captcha");
          return;
        }
        data.append("captcha", captcha);
        
        fetch(`${process.env.REACT_APP_API_URL}/auth/login`, {
          method: "post",
          body: data,
        }).then(async (res) => {
          let resp = await res.json();

          console.log(resp);
          //alert(resp.token)
          if (resp.token) {

            localStorage.setItem("token", resp.token);
            localStorage.setItem('email', document.getElementById('email').value);
            localStorage.setItem('password', document.getElementById('password').value);
            console.log(resp.permissions);
            // Store user permissions if provided in response
            if (resp.permissions) {
              localStorage.setItem("userPermissions", JSON.stringify(resp.permissions));
            } 

            toast.success(resp.response);
            navigate('/bookings');

          } else {

            toast.error(resp.response);

          }
          
         

          
        });









        
    }

  return (
    <div className="login">
        <form id='loginForm' onSubmit={handleSubmit}>
            <img src={img} style={{width:'5em', marginBottom:'2rem'}} alt="" />
            <input type='email' name='email' id='email' placeholder='Email' 
            onChange={(e) => setEmail(e.target.value)} value={email} />
            <input type='password' name='password' id='password' value={password} placeholder='Password' onChange={(e) => setPassword(e.target.value)} />
            <RECAPTCHA sitekey="6LehUMomAAAAAJl1yE63intOIHyqyPNwpqUQZ_gG"
            ref={captchaRef}

            />
            <button type='submit' className='btn btn-primary'>Log In</button>
        </form>
    </div>
  )
}

export default Login